// directives/css.ts
import "@adornis/ass/style.js";
import { noChange } from "lit";
import { Directive, directive, PartType } from "lit/directive.js";
import { styleMap } from "lit/directives/style-map.js";
var StyleDirective = class extends Directive {
  constructor(partInfo) {
    super(partInfo);
    if (partInfo.type !== PartType.ELEMENT)
      throw new Error("css can only be used as ElementPart");
    if (!(partInfo.element instanceof HTMLElement))
      throw new Error("css can only be used on HTMLElement");
  }
  render(styleInfo) {
    return noChange;
  }
  // stolen from lits styleMap directive https://github.com/lit/lit/blob/main/packages/lit-html/src/directives/style-map.ts
  update(part, [styleInfo]) {
    const { style } = part.element;
    if (this._previousStyleProperties === void 0) {
      this._previousStyleProperties = /* @__PURE__ */ new Set();
      for (const name in styleInfo) {
        this._previousStyleProperties.add(name);
      }
      const renderedStyle = styleMap({})["_$litDirective$"].prototype.render(styleInfo);
      part.element.setAttribute("style", renderedStyle);
      return this.render(styleInfo);
    }
    this._previousStyleProperties.forEach((name) => {
      if (styleInfo[name] == null) {
        this._previousStyleProperties.delete(name);
        if (name.includes("-")) {
          style.removeProperty(name);
        } else {
          style[name] = "";
        }
      }
    });
    for (const name in styleInfo) {
      const value = styleInfo[name];
      if (value != null) {
        this._previousStyleProperties.add(name);
        if (name.includes("-")) {
          style.setProperty(name, value);
        } else {
          style[name] = value;
        }
      }
    }
    return noChange;
  }
};
var css = directive(StyleDirective);
export {
  StyleDirective,
  css
};
